import { AsyncPipe, TitleCasePipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  imports: [
    RouterModule,
    AsyncPipe,
    TitleCasePipe
  ],
  standalone: true
})
export class HomeComponent {
  private readonly authService = inject(AuthService);

  authUserData$ = this.authService.authUserData$;
  groupedModules$ = this.authService.availableModulesGroups$;
}
